import React, { useState, useRef, useEffect } from "react";
import SwitchgearDesign from "./SwitchgearDesign";
import ControlRelayPanel from "./ControlRelayPanel";
import GeneratorRelayPanel from "./GeneratorRelayPanel";

const solutions = [
  {
    title: "Switchgear Panel Design",
    description:
      "Indoor and outdoor feeder switchgear for LV, MV, and HV power systems ensuring protection and control.",
  },
  {
    title: "Generator Panel Design",
    description:
      "Protection against overvoltage, overcurrent, and other faults to safeguard generators.",
  },
  {
    title: "Switchyard Panel Design",
    description:
      "Transmission and distribution power management with line control, transformers, bus bars, and protection.",
  },
];

function PowerSystemSolutions() {
  const [activeIndex, setActiveIndex] = useState(null);
  const popupRef = useRef();

  // Close popup when clicking outside the modal
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setActiveIndex(null);
      }
    };

    if (activeIndex !== null) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [activeIndex]);

  // Render content inside popup
  const renderPopupContent = () => {
    if (activeIndex === 0) return <SwitchgearDesign />;
    if (activeIndex === 1) return <GeneratorRelayPanel />;
    if (activeIndex === 2) return <ControlRelayPanel />;
    return null;
  };

  return (
    <section className="bg-blue-gray-400 text-white py-20 px-4 sm:px-6 relative">
      <h2 className="text-3xl sm:text-4xl font-semibold text-center mb-16 text-white">
        Safety Panel System Solution (2D & 3D)
      </h2>

      <div className="max-w-5xl mx-auto space-y-10 relative">
        {solutions.map((item, index) => (
          <div
            key={index}
            className="relative group"
            onClick={() => setActiveIndex(index)}
          >
            {/* Hover heading */}
            <div className="absolute -top-6 left-4 sm:left-6 bg-emerald-600 text-white text-xs sm:text-sm px-2 py-1 rounded shadow opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              Click to view details
              
            </div>

            <div className="flex items-start gap-4 sm:gap-6 cursor-pointer">
              <div className="w-12 h-16 sm:w-14 sm:h-20 bg-black border-2 border-orange-500 clip-arrow text-center flex items-center justify-center text-xl sm:text-2xl font-semibold">
                {index + 1}
              </div>
              <div>
                <h3 className="text-lg sm:text-xl font-semibold text-orange-400">
                  {item.title}
                </h3>
                <p className="text-gray-300 mt-1 text-sm sm:text-base">
                  {item.description}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Modal Popup */}
      {activeIndex !== null && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 px-4">
          <div
            ref={popupRef}
            className="bg-white text-gray-800 rounded-xl shadow-2xl w-full max-w-3xl max-h-[90vh] overflow-y-auto relative p-4 sm:p-6"
          >
            <button
              onClick={() => setActiveIndex(null)}
              className="absolute top-2 right-3 text-2xl text-gray-500 hover:text-red-500"
            >
              &times;
            </button>
            {renderPopupContent()}
          </div>
        </div>
      )}

      {/* Custom clip path for arrow */}
      <style jsx>{`
        .clip-arrow {
          clip-path: polygon(0 0, 100% 0, 100% 80%, 50% 100%, 0 80%);
        }
      `}</style>
    </section>
  );
}

export default PowerSystemSolutions;
